import {Button} from "react-bootstrap"

const Main = () => (
  <main className="mb-auto">
    <h1 className="display-4">Blackbird Rebellion</h1>
    <p className="lead">Alternative Rock from Hamburg, Germany.</p>
    <hr className="my-4"/>

    <div className="lead mb-3">
      New EP <i>Expedient Means</i> out now!
    </div>
    <div>
      <a href="https://on.soundcloud.com/uFQvsq8XqNjNsVmo7" target="_blank" rel="noreferrer">
        <img src="img/expedient_means.jpg" style={{width: 300, height: 300}} alt="Expedient Means" className="img-fluid mb-3"/>
      </a>
    </div>
    <div>
      <Button href="https://on.soundcloud.com/uFQvsq8XqNjNsVmo7" target="_blank" size="lg" variant="danger"
              className="fw-bold bg-opacity-25">
        Listen
        <div style={{fontSize: 8}}>on soundcloud.com</div>
      </Button>
    </div>
    <hr className="my-4"/>
  </main>
)

export default Main
